import type { DateRangeFilterChange } from "@/components/filters/DateRangeFilter";
import { DATE_RANGE_KEYS, calculateDateRange } from "@/utils/dateRangeUtils";

function getDefaultDateRange(): DateRangeFilterChange {
  const calculated = calculateDateRange(DATE_RANGE_KEYS.YESTERDAY);
  return {
    key: DATE_RANGE_KEYS.YESTERDAY,
    startDate: calculated.from,
    endDate: calculated.to,
    previousStartDate: calculated.previousFrom,
    previousEndDate: calculated.previousTo,
  };
}

let sharedDateRange: DateRangeFilterChange = getDefaultDateRange();

export function getSharedDateRange(): DateRangeFilterChange {
  return sharedDateRange;
}

export function setSharedDateRange(value: DateRangeFilterChange): void {
  sharedDateRange = value;
}
